import { isArray as _isArray } from 'lodash-es';
import { useCallback } from 'react';

import { useLanguageListQuery } from '@services/useLanguageListQuery';
import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

const translateField = ({
  item,
  profileIsoCode,
  languageId,
  field = 'name',
  translatesField = undefined,
  defaultField = undefined,
}) => {
  return (
    item?.[translatesField || 'translates']?.[profileIsoCode]?.[field] ||
    (_isArray(item?.[translatesField || 'translates'] || []) &&
      (item?.[translatesField || 'translates'] || []).find(
        (translate) => +translate.language_id === +languageId && translate.row_name === field,
      )?.text) ||
    item?.[defaultField || field] ||
    ''
  );
};

const useTranslate = () => {
  const { data: profileData } = useUserProfileQuery();
  const { data: languageListData } = useLanguageListQuery();

  const profileIsoCode = profileData?.user?.language_iso_code;
  const languageId = languageListData.find((item) => item.iso_code === profileIsoCode)?.id;

  const memoTranslateField = useCallback(
    (params) =>
      translateField({
        ...params,
        profileIsoCode,
        languageId,
      }),
    [profileIsoCode, languageId],
  );

  return {
    languageId,
    profileIsoCode,
    translateField: memoTranslateField,
  };
};

export default useTranslate;
